/* global swal, _, angular*/
import './style.less';
import { orderBy } from 'lodash';

export default function($log) {
  'ngInject';

  this.$onChanges = activate;

  const vm = this;

  vm.clear = () => {
    vm.searchModel = undefined;
    vm.ngModel = undefined;

    vm.ngCallback({ selected: vm.ngModel });
  };

  vm.searchModelChange = () => {
    if (vm.searchModel && typeof vm.searchModel !== 'string') {
      vm.ngModel = vm.searchModel.search_text;
    } else {
      vm.ngModel = undefined;
    }

    vm.ngCallback({ selected: vm.ngModel });
  };

  function activate() {
    $log.debug('Option Select component activated');

    if (!vm.ngList) {
      return;
    }

    if (vm.ngModel) {
      vm.searchModel = { search_text: vm.ngModel };
    } else {
      vm.searchModel = undefined;
    }

    vm.displayProp = vm.ngProp || 'name';

    const displayListDict = vm.ngList.reduce((acc, item) => {
      const search_text = item[vm.displayProp];

      if (search_text) acc[search_text.toLowerCase()] = { search_text };

      return acc;
    }, {});

    vm.displayList = orderBy(Object.values(displayListDict), ['search_text'], ['asc']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/optionSelect/controller.js